import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {LayoutComponent} from "../../layout/layout.component";
import {RincianKesehatanBsiComponent} from "./rincian-kesehatan-bsi.component";

const routes: Routes = [
  {
    path: 'rincian-kesehatan-bsi',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: RincianKesehatanBsiComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RincianKesehatanBsiRoutingModule { }
